export default "<p-chart type=\"pie\" [data]=\"data\"></p-chart>\r\n";